

































// NOTE: If you update how this file works, make sure to update
// templates/includes/footer/churn_tracking_block.html as well.
import { Component, Vue } from 'vue-property-decorator';
import { mapState, mapGetters } from 'vuex';
import { User } from 'frontend/types';
// tslint:disable-next-line
const noSsr = require('vue-no-ssr');

@Component({
  computed: {
    ...mapState('globals', ['user', 'loaded_profitwell_snippet', 'posted_profitwell_user_email']),
    ...mapState('profitwellApiToken', ['token']),
    ...mapGetters('globals', ['isAuthenticated']),
  },
  components: {
    'no-ssr': noSsr,
  },
})
export default class ChurnTrackingBlock extends Vue {
  private user!: User;

  // tslint:disable-next-line:variable-name
  private loaded_profitwell_snippet!: boolean | undefined;

  // tslint:disable-next-line:variable-name
  private posted_profitwell_user_email!: boolean | undefined;

  private isAuthenticated!: boolean;

  private token!: string;

  async mounted() {
    if (this.token) {
      await this.startProfitwell();
    }
  }

  private async startProfitwell() {
    if (!this.loaded_profitwell_snippet) {
      await this.$store.dispatch('globals/loadProfitwellSnippet');
      (window as any).profitwell('start', {});
    }
    await this.postUserEmailToProfitwell();
  }

  private async postUserEmailToProfitwell() {
    if (
      this.isAuthenticated &&
      this.loaded_profitwell_snippet &&
      !this.posted_profitwell_user_email
    ) {
      await this.$store.dispatch('globals/setProfitwellUserEmailAsPosted');
      (window as any).profitwell('user_email', this.user.email);
    }
  }
}
